// Teachers sign in with a username or their employee ID, but Supabase Auth only signs in by email,
// so each teacher's login is an internal email made from it. Teachers never see or type it. Must
// match LOGIN_DOMAIN in supabase/functions/manage-teacher/index.ts.
export const TEACHER_LOGIN_DOMAIN = 'teachers.pawigrade.local';

export const USERNAME_PATTERN = /^[A-Za-z0-9._-]{3,50}$/;

export function teacherLoginEmail(username) {
  return `${username.trim().toLowerCase()}@${TEACHER_LOGIN_DOMAIN}`;
}
